import * as React from 'react';

const playIcon = (
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_20319_10586)">
      <path
        d="M8.09876 1.59058H3.77444C3.48772 1.59058 3.21274 1.70448 3.01 1.90722C2.80726 2.10996 2.69336 2.38494 2.69336 2.67166V11.3203C2.69336 11.607 2.80726 11.882 3.01 12.0847C3.21274 12.2875 3.48772 12.4014 3.77444 12.4014H10.2609C10.5476 12.4014 10.8226 12.2875 11.0254 12.0847C11.2281 11.882 11.342 11.607 11.342 11.3203V4.83382L8.09876 1.59058Z"
        stroke="#0065FF"
        strokeWidth="1.24324"
        strokeLinecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M8.09863 1.59058V4.83382H11.3419"
        stroke="#0065FF"
        strokeWidth="1.24324"
        strokeLinecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M9.18077 7.53638H4.85645"
        stroke="#0065FF"
        strokeWidth="1.24324"
        strokeLinecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M9.18077 9.69849H4.85645"
        stroke="#0065FF"
        strokeWidth="1.24324"
        strokeLinecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M5.93753 5.37427H5.39699H4.85645"
        stroke="#0065FF"
        strokeWidth="1.24324"
        strokeLinecap="round"
        stroke-linejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_20319_10586">
        <rect
          width="12.973"
          height="12.973"
          fill="white"
          transform="translate(0.53125 0.509277)"
        />
      </clipPath>
    </defs>
  </svg>
);

export default playIcon;
